import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import { WithNamespaces, withNamespaces } from "react-i18next";
import UserAccount from "src/components/UserAccount";
import { HeaderPage } from "src/components/HeaderPage";

const mapStateToProps = (state: AppState, props) => {
  return { user: state.user };
};
type PropsWithMapState = ReturnType<typeof mapStateToProps> & WithNamespaces;

class UserAccountContainerToConnect extends React.Component<PropsWithMapState> {
  render() {
    return (
      <div>
        <div className="mb-5">
          <HeaderPage title={this.props.t("user.account.title")} />
        </div>
        <UserAccount profil={this.props.user.profil} />
      </div>
    );
  }
}

export const UserAccountContainer = withNamespaces()(
  connect(
    mapStateToProps,
    null
  )(UserAccountContainerToConnect)
);



// WEBPACK FOOTER //
// ./src/containers/UserAccountContainer.tsx